import { COLOR_PRIMARY, TEXT_FONT_FAMILY } from "../theme";
import styled from "@emotion/styled";

export const LinkButton = styled.button`
  background: none;
  border: none;
  color: ${COLOR_PRIMARY};
  text-decoration: underline;
  cursor: pointer;
  font-family: ${TEXT_FONT_FAMILY};
  font-weight: 300;
`;
